import { Dialog, DialogContent, DialogContentText, Typography, DialogActions, Button } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useNavigate, useParams } from "react-router-dom";

type TableJoinFailedDialogProps = {
  reason: string | null;
  setReason: Dispatch<SetStateAction<string | null>>;
};
export function TableJoinFailedDialog({ reason, setReason }: TableJoinFailedDialogProps) {
  const navigate = useNavigate();
  const params = useParams();

  function onDialogDismiss() {
    setReason(null);
    navigate("/projects/" + params.projectSlug);
  }
  return (
    <Dialog open={reason !== null} onClose={onDialogDismiss} aria-describedby="alert-dialog-description">
      <DialogContent>
        <DialogContentText id="alert-dialog-description" component={"div"}>
          <Typography gutterBottom>Joining table failed. Reason: {reason}</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDialogDismiss}>To project page</Button>
      </DialogActions>
    </Dialog>
  );
}
